import { css } from '@emotion/css';

import { COLORS } from '@/styles/colors';

export const container = (onTreatment?: boolean) => css`
  padding: 2px 4px;
  border-radius: 4px;
  background-color: ${onTreatment ? COLORS.GREEN_20 : COLORS.ALPHA_GRAY_15};
`;
